import { useTranslation } from "react-i18next";
import "../cs.scss";
import "./newkit.scss";
import { Breadcrumb, Button, Col, Form, Image, Input, Radio, Row, Select, Steps, Tooltip } from "antd";
import { _adr } from "../../../../address";
import { DeleteOutlined, EditOutlined, HomeOutlined } from "@ant-design/icons";
import { Content } from "antd/es/layout/layout";
import { useEffect, useState } from "react";
import { ExportDocument, exportNormalFile, fileToformData, urltoFile } from "../../../../tools/tools";
import UploadImages from "../../../auxiliary/uploadImages/upload";
import { useAPIPublic, useDealer } from "../../../../tools/api";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { simcardPurchase } from "../../../../reducer/serviceReducer";
import Loading from "../../../auxiliary/loader/loading";
import ResizeImage from "../../../auxiliary/resizeImg/resizeImage";
import { Roles } from "../../../../tools/services";
const CSNewKit = () => {
  const [t] = useTranslation("global");
  const [frmValid] = Form.useForm();
  const location = useLocation();
  const { querySimSwapReason, addDocument } = useAPIPublic();
  const { checkKitNOForSW, reserveKitNo } = useDealer();
  const [documentType, setDocumentType] = useState("CertNoCard");
  const [txtReason, setTxtReason] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [msisdn, setMsisdn] = useState();
  const [certno, setCertno] = useState();
  const [token, setToken] = useState();
  const nav = useNavigate();
  const formData = useSelector((state) => state?.from?.swchange);
  const { _currentUser } = useSelector((state) => state?.another);
  const dispatch = useDispatch();
  const handleChangeTypeDocument = (e) => {
    frmValid.setFieldValue("typeforupload", e.target.value);
    setDocumentType(e.target.value);
  };

  const [reasonChange, setReasonChange] = useState([]);
  useEffect(() => {
    const CallReason = async () => {
      let response = await querySimSwapReason();
      if (response) {
        setReasonChange(response);
      }
    };
    if (formData) {
      frmValid.setFieldValue("photo", formData?.photo);
      setMsisdn(formData?.msisdn);
      setCertno(formData?.certno);
      setTxtReason(formData?.reasontext);
      setToken(formData?.token);
    } else {
      setMsisdn(location?.state?.msisdn);
      setCertno(location?.state?.certno);
      setToken(location?.state?.token);
    }
    CallReason();
  }, []);

  const handleSubmit = async () => {
    setIsLoading(true);
    try {
      let valid = await frmValid.validateFields();
      if (valid) {
        ///cal service check kit
        let payload = {
          kitNo: valid.kitNo,
          msisdn: msisdn,
        };
        let res = await checkKitNOForSW(payload);
        if (res && !res.HasError) {
          //call service reserv kit
          payload = {
            KitNo: valid.kitNo,
          };
          res = await reserveKitNo(payload);
          if (res && !res.HasError) {
            //call service add Document

            res = await addDocument(await fileToformData(valid.photo), valid.typeforupload);

            if (res && !res.HasError) {
              dispatch(
                simcardPurchase({
                  swchange: {
                    msisdn: msisdn,
                    certno: certno,
                    token: token,
                    reason: valid.reason,
                    kitno: valid.kitNo,
                    photo: valid.photo,
                    documentid: res.Result,
                    reasontext: txtReason,
                    typeforupload: valid.typeforupload,
                    certtype: location?.state?.certtype,
                  },
                }),
              );
              nav(_adr.Root + _adr.SimCardReplacement.Index + _adr.SimCardReplacement.Replacement + _adr.SimCardReplacement.PreFactor);
            }
          }
        }
      }
    } catch (error) {}
    setIsLoading(false);
  };
  const handleGetImage = async (value) => {
    frmValid.setFieldValue("photo", value);
  };
  return (
    <>
      <div className="container-main container-cs">
        <div className="g-hold-title-of-page">
          <Breadcrumb
            className="breadcrumbs"
            items={[{ href: _adr.Root + _adr.Home, title: <HomeOutlined /> }, { title: t("simcardreplacement.validPage.title") }]}
          />
          <div className="title-page">
            <h3>{t("simcardreplacement.validPage.title")}</h3>
          </div>
        </div>
        <div className="g-layout-content">
          <Content className="g-layout-main cs-container">
            <div className="g-format-page">
              <div className="g-body-format-page">
                <div className="g-format-steps">
                  <div className="holder-step">
                    <Steps
                      size="small"
                      className="step-wizard"
                      current={1}
                      items={[
                        {
                          title: "احراز هویت",
                        },
                        {
                          title: "مشخصات سیم‌کارت",
                        },
                        {
                          title: "پیش فاکتور",
                        },
                        {
                          title: "فرم تعویض سیم‌کارت",
                        },
                      ]}
                    />
                  </div>
                </div>
                <div className="holder-new-kit">
                  <Form
                    form={frmValid}
                    layout="vertical"
                    initialValues={{
                      reason: formData?.reason,
                      kitNo: formData?.kitno,
                      typeforupload: formData?.typeforupload,
                      photo: formData?.photo,
                    }}
                  >
                    <Row>
                      <Col span={8} xl={8} lg={12} md={15} xs={24} sm={24}>
                        <Form.Item
                          className="input-normal"
                          style={{ padding: "0" }}
                          label="شماره کیت جدید"
                          name="kitNo"
                          rules={[
                            {
                              required: true,
                              message: t("validation.required"),
                            },
                            {
                              pattern: new RegExp(/^[0-9]{9}$/),
                              message: t("validation.regex"),
                            },
                          ]}
                        >
                          <Input dir="ltr" autoComplete="off" placeholder="شماره کیت جدید را وارد کنید" inputMode="numeric" maxLength={9} showCount />
                        </Form.Item>
                      </Col>
                    </Row>
                    <Row>
                      <Col span={8} xl={8} lg={12} md={15} xs={24} sm={24}>
                        <Form.Item
                          className="input-normal"
                          name="reason"
                          label="علت تعویض سیم کارت"
                          rules={[
                            {
                              required: true,
                              message: t("validation.required"),
                            },
                          ]}
                        >
                          <Select
                            placeholder="علت تعویض سیم کارت"
                            onChange={(item, option) => {
                              setTxtReason(option.children);
                            }}
                          >
                            {reasonChange.map((item, key) => (
                              <Select.Option key={key} value={item.value}>
                                {item.name}
                              </Select.Option>
                            ))}
                          </Select>
                        </Form.Item>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Item className="input-normal" name="typeforupload" initialValue={documentType}>
                          <Radio.Group value={documentType} onChange={handleChangeTypeDocument}>
                            <Radio value="CertNoCard">تصویرکارت ملی یا شناسنامه جدید</Radio>
                            {_currentUser?.roles?.includes(Roles.Dealer_SimSwap_B2C_UploadPassportDoc) && (
                              <Radio value="Passport">تصویر پاسپورت</Radio>
                            )}
                          </Radio.Group>
                        </Form.Item>
                      </Col>
                    </Row>
                    <Row gutter={16}>
                      <Col span={8} xl={8} lg={15} md={20} xs={24} sm={24}>
                        <Form.Item
                          name="photo"
                          rules={[
                            {
                              required: true,
                              message: t("validation.required"),
                            },
                          ]}
                          label="تصویر مدرک"
                        >
                          <ResizeImage exportImage={handleGetImage} />
                        </Form.Item>
                      </Col>
                      {/* <Col span={8} style={{ margin: "auto 0" }}>
                        <ul>
                          <li>
                            بارگذاری کارت ملی جدید یا شناسنامه جدید یا کارت ملی
                            قدیمی همراه با رسید کارت ملی جدید
                          </li>
                          <li>فرمت ها و حجم و رزولوشن قابل قبول</li>
                          <li>توضیح در مورد مشخص بودن گوشه های تصویر مدارک</li>
                        </ul>
                      </Col> */}
                    </Row>
                  </Form>
                </div>
              </div>
              <div className="g-footer-format-page">
                <div className="holder-button">
                  <Button className="btn-normal btn-aptel" htmlType="submit" type="primary" danger onClick={handleSubmit}>
                    مرحله بعد
                  </Button>
                  <Button
                    className="btn-normal"
                    onClick={() => {
                      nav(_adr.Root + _adr.SimCardReplacement.Index + _adr.SimCardReplacement.Replacement + _adr.SimCardReplacement.ValidMsisdn);
                    }}
                  >
                    بازگشت
                  </Button>
                </div>
              </div>
            </div>
          </Content>
        </div>
      </div>

      <Loading isOpen={isLoading} />
    </>
  );
};

export default CSNewKit;
